import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#direction-clip0_2249_1796)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M12.707 3.121a1 1 0 0 0-1.414 0L3.12 11.293a1 1 0 0 0 0 1.414L7 16.586V13a3 3 0 0 1 3-3h4.586l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L14.586 12H10a1 1 0 0 0-1 1v5.586l2.293 2.293a1 1 0 0 0 1.414 0l8.172-8.172a1 1 0 0 0 0-1.414zM9.879 1.707a3 3 0 0 1 4.242 0l8.172 8.172a3 3 0 0 1 0 4.242l-8.172 8.172a3 3 0 0 1-4.242 0L1.707 14.12a3 3 0 0 1 0-4.242z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "direction-clip0_2249_1796" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }